import { ConsumerEntity } from '../../consumer/consumer.entity';
import { Relation } from '../../core/decorators/relation.decorator';
import { BaseEntity } from '../../core/entities/base.entity';
import { ConsumerData } from '../../core/types';
import { RelationRef } from '../../core/types/entity-types';
import { SequenceEntity } from '../../sequence/sequence.entity';
import { SubjectEntity } from '../../subject/subject.entity';

export interface ExerciseKind { value: string, option: string }
export interface ExerciseConsumer { id: string, name: string }
export interface ExerciseCompetency { id: string, name: string }

export interface NlpOptions {
  enabled_components?: Record<string, boolean>
  enabled_categories?: Record<string, boolean>
  ignore_feedback?: string[]
  content_matching_based_on?: 'lemma' | 'token'
  use_exercise_text_as_lexicon?: boolean
}

export interface LastNlpResult {
  options?: NlpOptions
  fields?: Record<string, { options?: NlpOptions }>
  body?: string
  status?: unknown
}

export interface LearnItemConfig {
  exerciseSubKind?: string
  materialTabName?: string
  lastNLPResult?: LastNlpResult
  kiService?: boolean
  [key: string]: unknown
}

export interface QuantityError {
  from: number
  to: number
  message: string
}

export class ExerciseEntity extends BaseEntity {
  subjectId!: string;
  consumerId!: string;
  name!: string;
  kind!: string;
  config!: LearnItemConfig;
  assignments!: string[];
  assets!: string[];
  updated!: Date;
  version!: number;
  approval!: string;
  active!: boolean;
  lastVersion!: string;
  sortName!: string;
  correct!: string[];
  changedBy!: string;
  copyRestricted!: boolean;
  consumerData!: ConsumerData;
  pages!: string[];
  conditionalErrors!: string[];
  quantityErrors!: QuantityError[];

  @Relation()
  consumers?: RelationRef<ConsumerEntity>[];

  @Relation()
  subjects?: RelationRef<SubjectEntity>[];

  @Relation()
  sequences?: RelationRef<SequenceEntity>[];
}
